import apiClient from './ApiClient';

export class BookingRequestRepository {
	constructor(client) {
		this.client = client;
		this.basePath = '/api/booking-requests';
	}

	async create(payload) {
		return this.client.post(this.basePath, payload);
	}

	async getByReferenceCode(referenceCode) {
		return this.client.get(`${this.basePath}/status/${encodeURIComponent(referenceCode)}`);
	}

	async listAdmin(params = {}) {
		return this.client.get(`${this.basePath}/admin`, params);
	}

	async startWorkflow(id, workflowId) {
		return this.client.post(`${this.basePath}/${id}/workflow`, { workflowId });
	}

	async updateStatus(id, status, companyNote = null) {
		return this.client.patch(`${this.basePath}/${id}/status`, { status, companyNote });
	}

	async complete(id) {
		return this.client.patch(`${this.basePath}/${id}/complete`);
	}

	async cancel(id, reason = null) {
		return this.client.patch(`${this.basePath}/${id}/cancel`, { reason: reason || null });
	}

	async processWorkflowDecision(instanceId, decision, comment) {
		return this.client.post(`${this.basePath}/workflow/${instanceId}/decision`, {
			decision,
			comment: comment || null,
		});
	}

	async initiatePayment(id, callbackUrl) {
		return this.client.post(`${this.basePath}/${id}/initiate-payment`, { callbackUrl });
	}

	async finalizeItemPrice(requestId, serviceItemId, finalUnitPrice) {
		return this.client.patch(
			`${this.basePath}/${encodeURIComponent(requestId)}/items/${encodeURIComponent(serviceItemId)}/final-price`,
			{ finalUnitPrice }
		);
	}

	async verifyPayment(reference) {
		return this.client.post(
			`${this.basePath}/verify-payment?reference=${encodeURIComponent(reference)}`
		);
	}
}

export default new BookingRequestRepository(apiClient);
